// Scheduling related JS
import './activate_now.js';
import './auto_activation_date.js';
import './appointment.js';
